import SimpleCard from './SimpleCard';

export default SimpleCard;
